import React, { useState } from 'react';
import { Quote, X, CheckCircle2 } from 'lucide-react';
import '../styles/AdminTestimonialsSection.css';

const TESTIMONIALS = [
  {
    quote: "Joz HRM transformed how we hire. We reduced our time-to-hire by 40% and our engineering managers are thrilled they only speak to fully vetted, high-quality applicants.",
    name: "Sarah Jenkins",
    role: "VP of Talent Acquisition, TechCorp",
    initial: "S"
  },
  {
    quote: "The AI proctoring and detailed analytics give us complete confidence in our remote hiring process. It's like having a senior engineer conduct every initial screen.",
    name: "David Chen",
    role: "Director of Engineering, Innovate.io",
    initial: "D"
  },
  {
    quote: "Scaling our university recruiting used to be a nightmare. Now, we send a single link and review the AI-generated scorecards the next morning. It's magic.",
    name: "Elena Rodriguez",
    role: "Head of University Programs, GlobalBank",
    initial: "E"
  },
  {
    quote: "We've eliminated technical phone screens entirely. The platform’s ability to generate custom questions from our JDs ensures every candidate is assessed fairly and rigorously.",
    name: "Marcus Thorne",
    role: "CTO, NextGen Systems",
    initial: "M"
  },
  {
    quote: "The side-by-side scorecard comparison is a game-changer. We no longer debate candidate performance—the data clearly highlights who the strongest engineers are.",
    name: "Priya Patel",
    role: "Engineering Manager, FinEdge",
    initial: "P"
  },
  {
    quote: "Security was our biggest concern with remote assessments. The live proctoring and integrity checks have caught multiple issues we would have otherwise missed.",
    name: "James Wilson",
    role: "VP Engineering, SecureNet",
    initial: "J"
  }
];

const AdminTestimonialsSection: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      setIsModalOpen(false);
      setIsSubmitted(false);
    }, 2500);
  };

  return (
    <section className="admin-ts-section" id="testimonials">
      <div className="admin-ts-bg-pattern" />
      <div className="admin-ts-inner">
        <div className="admin-ts-header">
          <h2 className="admin-ts-title">Trusted by Leading Teams</h2>
          <p className="admin-ts-sub">See how top organizations are scaling their engineering teams and maintaining a high bar with our platform.</p>
          <button className="admin-ts-post-btn" onClick={() => setIsModalOpen(true)}>
            Share Your Experience
          </button>
        </div>

        <div className="admin-ts-marquee-container">
          <div className="admin-ts-marquee">
            {[...TESTIMONIALS, ...TESTIMONIALS].map((t, i) => (
              <div key={i} className="admin-ts-card">
                <div>
                  <Quote size={40} className="admin-ts-quote-icon" />
                  <p className="admin-ts-text">"{t.quote}"</p>
                </div>
                <div className="admin-ts-author">
                  <div className="admin-ts-avatar">{t.initial}</div>
                  <div className="admin-ts-info">
                    <h4>{t.name}</h4>
                    <p>{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="admin-ts-modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="admin-ts-modal" onClick={e => e.stopPropagation()}>
            <button className="admin-ts-modal-close" onClick={() => setIsModalOpen(false)}>
              <X size={24} />
            </button>

            {isSubmitted ? (
              <div className="admin-ts-success">
                <CheckCircle2 size={64} className="admin-ts-success-icon" />
                <h3 className="admin-ts-modal-title">Thank You!</h3>
                <p style={{ color: '#475569' }}>Your testimonial has been submitted successfully and is pending review.</p>
              </div>
            ) : (
              <>
                <h3 className="admin-ts-modal-title">Submit a Testimonial</h3>
                <form className="admin-ts-form" onSubmit={handleSubmit}>
                  <div className="admin-ts-input-group">
                    <label>Your Name</label>
                    <input type="text" required placeholder="e.g. Jane Doe" />
                  </div>
                  <div className="admin-ts-input-group">
                    <label>Job Title & Company</label>
                    <input type="text" required placeholder="e.g. VP of Engineering, Acme Corp" />
                  </div>
                  <div className="admin-ts-input-group">
                    <label>Your Experience</label>
                    <textarea required placeholder="How has Joz HRM helped your hiring process?" />
                  </div>
                  <button type="submit" className="admin-ts-submit-btn">
                    Submit Testimonial
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default AdminTestimonialsSection;
